import Api from "@/service/common/api";
import {NotificationItem} from "@/service/flow/notification/type";
import useSWR from "swr";
import {ListResult, WhereConditionInterface} from "@/shared/types/data";
import request from "@/shared/libs/axios";

class Notification extends Api<NotificationItem> {
  constructor() {
    super({
      prefix: "sys",
      controller: "notification",
      dbAbbr: "sn",
    });
  }

  toMeNotificationPage  = (params:WhereConditionInterface) =>{
    return request.post<ListResult<any>>("sys/notification/toMeNotificationPage",params);
  }

  readNotification = (id:string)=>{
    return request.get("sys/notification/readNotification/"+id);
  }

  confirmNotification = (id:string)=>{
    return request.get("sys/notification/confirmNotification/"+id);
  }

  releaseNotification = (id:string) =>{
    return request.get("sys/notification/releaseNotification/"+id);
  }

  findDetailsByNotificationId = (id:string)=>{
    return request.get<[]>("sys/notification/findDetailsByNotificationId/"+id);
  }

  findToMeNotification = (userId:string)=>{
    return request.get<[]>("sys/notification/findToMeNotification/"+userId, { noLoading: true } as any)
  }

}

export const notificationApi = new Notification();


export const useNotificationList = (
    queryParams: Parameters<typeof notificationApi.queryPage>[0]
) => {
  return useSWR(
      `notification-list-${JSON.stringify(queryParams)}`,
      () => notificationApi.queryPage(queryParams),
      { errorRetryCount: 0, revalidateOnFocus: false }
  );
};

export const useToMeNotificationList = (
    queryParams: WhereConditionInterface
) => {
  return useSWR(
      `notification-to-me-list-${JSON.stringify(queryParams)}`,
      () => notificationApi.toMeNotificationPage(queryParams),
      { errorRetryCount: 0, revalidateOnFocus: false }
  );
};

export const useDetailsList = (
    id: string
) => {
  return useSWR(
      `notification-details-list-id}`,
      () => notificationApi.findDetailsByNotificationId(id),
      { errorRetryCount: 0, revalidateOnFocus: false }
  );
};

